import Color from './color';
import {Types} from 'gamebox';

Types.Color = Color;

export default Types;
